module.exports = __webpack_public_path__ + "img/logo.48b80c6c.png";